import React from 'react';
import { C3_CAMPAIGNS, type C3Campaign } from '../../mock/c3';
import Dialog from '../../ui/Dialog';

interface CampaignsModalProps {
  focusId?: string;
  onClose: () => void;
  onSelectMember: (incidentId: string) => void;
  /** Opens the campaign's screen. */
  onOpenCampaign: (campaignId: string) => void;
}

const CampaignsModal: React.FC<CampaignsModalProps> = ({ focusId, onClose, onSelectMember, onOpenCampaign }) => {
  const camps: C3Campaign[] = C3_CAMPAIGNS;

  return (
    <Dialog
      onClose={onClose}
      title={
        <>
          Active Campaigns
          <span className="inline-block text-[12px] font-bold text-c3-purple border border-c3-purple rounded px-1.5 ml-2 align-middle tracking-wider">
            CORRELATED SETS
          </span>
        </>
      }
    >
      <div className="text-c3-mute text-sm mb-4">
        Campaign membership is written to each member incident’s audit trail.
      </div>
      {camps.map((c) => (
        <div
          key={c.id}
          className={`bg-c3-tile border rounded-xl px-[18px] py-4 mb-3 ${
            focusId === c.id || (!focusId && c.id === camps[0].id)
              ? 'border-c3-red ring-1 ring-crit/30'
              : 'border-c3-tile-bd'
          }`}
        >
          <div className="flex items-center gap-2.5 mb-2">
            <span className="text-[12px] font-bold text-c3-red border border-c3-red rounded px-2 py-0.5">
              {c.id}
            </span>
            <span className="font-bold text-[16px]">{c.name}</span>
            <span className={`ml-auto text-xs font-bold ${c.statec.includes('amber') ? 'text-c3-amber' : 'text-c3-blue'}`}>
              {c.state}
            </span>
          </div>
          <p className="text-[14px] text-c3-mute my-1.5">{c.summary}</p>
          <div className="text-c3-mute text-xs mb-2">
            {c.members.length} members · {c.alerts} alerts · {c.sev.toUpperCase()}
          </div>
          <div className="flex flex-wrap items-center gap-2">
            <button type="button" className="c3-pill" onClick={() => onOpenCampaign(c.id)}>
              Open campaign
            </button>
            {c.members.map((m) => (
              <button
                key={m}
                type="button"
                className="text-[13px] text-c3-lpurple bg-acc/10 border border-c3-purple rounded-md px-3 py-1 cursor-pointer hover:brightness-125"
                onClick={() => onSelectMember(m)}
              >
                {m}
              </button>
            ))}
          </div>
        </div>
      ))}
      <div className="flex gap-3 mt-4">
        <button type="button" className="c3-btn c3-btn-ghost" onClick={onClose}>
          Close
        </button>
      </div>
    </Dialog>
  );
};

export default CampaignsModal;
